import { render } from "./ForgotPassword.vue?vue&type=template&id=8d6b77e0"
import script from "./ForgotPassword.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script